import Vue from 'vue'
import VueRouter from 'vue-router'
/*中文 */
// import Home from '@/views/Home/Home.vue'
// import ActivityDetail from '@/views/Activity/Detail.vue'
// import User from '@/views/User/User.vue'
// import UserProfile from '@/views/User/Profile.vue'
// import UserModify from '@/views/User/Modify.vue'
// import UserActivity from '@/views/User/Activitys.vue'
// import UserActivityDetail from '@/views/User/ActivityDetail.vue'
// import WxAuth from '@/views/User/WxAuth.vue'
// import Qiandao from '@/views/QianDao/QianDao.vue'
// import ShowCodes from '@/views/QianDao/ShowCodes.vue'
// import CodeView from '@/views/QianDao/Code.vue'
import RankIndex from '@/views/Rank/Index.vue'
import RankDetail from '@/views/Rank/Detail.vue'
// import UserPrivacy from '@/views/User/Privacy.vue'
// import UserAuthorization from '@/views/User/Authorization.vue'
import UserCertificate from '@/views/User/Certificate.vue'
/**英文 */
// import Home_en from '@/views/Home_en/Home.vue'
// import ActivityDetail_en from '@/views/Activity_en/Detail.vue'
// import User_en from '@/views/User_en/User.vue'
// import UserProfile_en from '@/views/User_en/Profile.vue'
// import UserModify_en from '@/views/User_en/Modify.vue'
// import UserActivity_en from '@/views/User_en/Activitys.vue'
// import UserActivityDetail_en from '@/views/User_en/ActivityDetail.vue'
// import WxAuth_en from '@/views/User_en/WxAuth.vue'
// import Qiandao_en from '@/views/QianDao_en/QianDao.vue'
// import ShowCodes_en from '@/views/QianDao_en/ShowCodes.vue'
// import CodeView_en from '@/views/QianDao_en/Code.vue'
import RankIndex_en from '@/views/Rank_en/Index.vue'
import RankDetail_en from '@/views/Rank_en/Detail.vue'
// import UserPrivacy_en from '@/views/User_en/Privacy.vue'
// import UserAuthorization_en from '@/views/User_en/Authorization.vue'
import UserCertificate_en from '@/views/User_en/Certificate.vue'
import Demo from '@/views/Demo/Demo.vue'

Vue.use(VueRouter)

// 配置路由的数组
const routes = [
	{
	  path: '/Demo/Demo',
	  component: Demo
	},
  /*****中文******************************************************************/
  // {
  //   path: '/',
  //   component: Home
  // },
  // {
  //   path: '/user',
  //   component: User
  // },
  // {
  //   path: '/user/profile',
  //   component: UserProfile
  // },
  // {
  //   path: '/user/modify',
  //   component: UserModify,
  // },
  // {
  //   path: '/user/modify/:id',
  //   component: UserModify,
  //   props: true
  // },
  // {
  //   path: '/user/activitys',
  //   component: UserActivity
  // },
  // {
  //   path: '/user/activitys/detail/:id',
  //   component: UserActivityDetail,
  //   props: true
  // },
  // {
  //   path: '/user/wxauth',
  //   component: WxAuth
  // },
  // {
  //   path: '/activity/detail/:id',
  //   component: ActivityDetail,
  //   props: true
  // },
  // // 签到相关页面
  // {
  //   path: '/qiandao',
  //   component: Qiandao
  // },
  // {
  //   path: '/qiandao/showcodes/:ids',
  //   component: ShowCodes,
  //   props: true
  // },
  // // 参赛码相关
  // {
  //   path: '/code/:id/:scence',
  //   component: CodeView,
  //   props: true
  // },
  // 排名相关页面
  {
    path: '/rank/index',
    component: RankIndex
  },
  {
    path: '/rank/detail/:id/:scence',
    component: RankDetail,
    props: true
  },
  // //用户信息授权协议
  // {
  //   path: '/user/authorization',
  //   component: UserAuthorization
  // },
  //  //用户信息隐私保护
  //  {
  //   path: '/user/privacy',
  //   component: UserPrivacy
  // },
  // //完赛证
  // {
  //   path: '/user/certificate/:id',
  //   component: UserCertificate,
  //   props: true
  // },
  /*****英文******************************************************************/
  // {
  //   path: '/en',
  //   component: Home_en
  // },
  // {
  //   path: '/en/user',
  //   component: User_en
  // },
  // {
  //   path: '/en/user/profile',
  //   component: UserProfile_en
  // },
  // {
  //   path: '/en/user/modify',
  //   component: UserModify_en
  // },
  // {
  //   path: '/en/user/modify/:id',
  //   component: UserModify_en,
  //   props: true
  // },
  // {
  //   path: '/en/user/activitys',
  //   component: UserActivity_en
  // },
  // {
  //   path: '/en/user/activitys/detail/:id',
  //   component: UserActivityDetail_en,
  //   props: true
  // },
  // {
  //   path: '/en/user/wxauth',
  //   component: WxAuth_en
  // },
  // {
  //   path: '/en/activity/detail/:id',
  //   component: ActivityDetail_en,
  //   props: true
  // },
  // // 签到相关页面
  // {
  //   path: '/en/qiandao',
  //   component: Qiandao_en
  // },
  // {
  //   path: '/en/qiandao/showcodes/:ids',
  //   component: ShowCodes_en,
  //   props: true
  // },
  // // 参赛码相关
  // {
  //   path: '/en/code/:id/:scence',
  //   component: CodeView_en,
  //   props: true
  // },
  // 排名相关页面
  {
    path: '/en/rank/index',
    component: RankIndex_en
  },
  {
    path: '/en/rank/detail/:id/:scence',
    component: RankDetail_en,
    props: true
  }
  // //用户信息授权协议
  // {
  //   path: '/en/user/authorization',
  //   component: UserAuthorization_en
  // },
  //  //用户信息隐私保护
  //  {
  //   path: '/en/user/privacy',
  //   component: UserPrivacy_en
  // },
  // //完赛证
  // {
  //   path: '/en/user/certificate/:id',
  //   component: UserCertificate_en,
  //   props: true
  // }
]

// 创建路由对象
const router = new VueRouter({
  routes
})

export default router
